import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Input from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import {
  useAddBrand,
  useGetBrand,
  useUpdateBrand,
} from "../../produk/api/product/brand/resolver";

interface IForm {
  idBrand?: string;
}

export default function Form({ idBrand }: IForm) {
  const [brand, setBrand] = useState<undefined | string>("");
  const { mutate: mutateAdd, isLoading: loadingAdd } = useAddBrand();
  const { mutate: mutateUpdate, isLoading: loadingUpdate } = useUpdateBrand();
  const { data: dataRawBrand, isLoading: fetchBrand } = useGetBrand({
    product_brand_id: idBrand,
  });
  const [error, setError] = useState<string>("");
  const loading = loadingAdd || loadingUpdate;

  useEffect(() => {
    if (idBrand && dataRawBrand) {
      setBrand(dataRawBrand.data.data.brand_name);
    }
  }, [idBrand, dataRawBrand]);

  const handleAdd = () => {
    if (brand === undefined) {
      setError("Kolom ini wajib di isi");
      return;
    }
    setError("");
    if (idBrand) {
      mutateUpdate({ brand_name: brand, product_brand_id: idBrand });
    } else {
      mutateAdd({ brand_name: brand });
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12}>
        <Input.Text
          isFetching={fetchBrand}
          label="Nama Brand"
          onChange={(e) => setBrand(e)}
          value={brand}
          error={error}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        justifyContent={"flex-end"}
        mt={2}
      >
        <LoadingButton
          text={idBrand ? "Update" : "Submit"}
          isLoading={loading}
          onClick={handleAdd}
        />
      </Grid>
    </Grid>
  );
}
